import api from './ApiClient';
import type { Project, ProjectsResponse } from 'types/Projects';

export const ProjectService = {
  async getProjects(page = 1, limit = 5): Promise<ProjectsResponse> {
    const response = await api.get<ProjectsResponse>('/projects', {
      params: { page, limit },
    });
    return response.data;
  },

  async getProjectById(id: string | number): Promise<Project> {
    const response = await api.get<Project>(`/projects/${id}`);
    return response.data;
  },
  async getProjectsCount(): Promise<number> {
    const response = await api.get<{ total: number }>('/projects/count');
    return response.data.total;
  },
};
